import { Axios } from "./request";

const API_URL = "usersapi/v1/personal/";

export const PERSONAL_INFORMATION_API = {
  GetPersonalInformation: () => {
    return Axios.get(`${API_URL}GetPersonalInformation`);
  },
  AddPersonalInformation: (body) => {
    return Axios.post(`${API_URL}AddPersonalInformation`, body);
  },
  EditPersonalInformation: (body) => {
    return Axios.put(`${API_URL}EditPersonalInformation`, body);
  },
  GetDetailPersonalInformation: (profileNumber) => {
    return Axios.get(`${API_URL}GetDetailPersonalInformation?profileNumber=${profileNumber}`);
  },
  GetDetailPersonalInformationAfterApprovalInspector: (profileNumber) => {
    return Axios.get(
      `${API_URL}GetDetailPersonalInformationAfterApprovalInspector?profileNumber=${profileNumber}`
    );
  },
};
